import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { userService } from '../services/userService';

const UserContext = createContext();

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser must be used within UserProvider');
  }
  return context;
};

// 刷新间隔（毫秒）
const REFRESH_INTERVAL = 3000; // 3秒

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [walletAddress, setWalletAddress] = useState('');
  const [chainId, setChainId] = useState('');
  const [loading, setLoading] = useState(false);

  // 加载用户数据
  const loadUserData = useCallback(async (address) => {
    if (!address) return;
    
    try {
      setLoading(true);
      const userData = await userService.getUserByAddress(address);
      setUser(userData);
    } catch (error) {
      console.error('加载用户数据失败:', error);
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  // 从localStorage恢复钱包地址
  useEffect(() => {
    const savedAddress = localStorage.getItem('cw_account');
    const savedChain = localStorage.getItem('cw_chain');
    if (savedAddress) {
      setWalletAddress(savedAddress);
      setChainId(savedChain || '');
      loadUserData(savedAddress);
    }
  }, [loadUserData]);

  // 定时刷新用户数据
  useEffect(() => {
    if (!walletAddress) return;

    const intervalId = setInterval(() => {
      loadUserData(walletAddress);
    }, REFRESH_INTERVAL);

    return () => clearInterval(intervalId);
  }, [walletAddress, loadUserData]);

  // 设置钱包地址
  const setWallet = (address, chain) => {
    setWalletAddress(address);
    setChainId(chain);
    if (address) {
      localStorage.setItem('cw_account', address);
      localStorage.setItem('cw_chain', chain);
      loadUserData(address);
    } else {
      localStorage.removeItem('cw_account');
      localStorage.removeItem('cw_chain');
      setUser(null);
    }
  };

  const value = {
    user,
    walletAddress,
    chainId,
    loading,
    setWallet,
    loadUserData,
  };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

